import React from 'react';
import Device from "./Device";

let newliner = str => str.split(/\n/).map((s, i) => <div key={i}>{s}</div>)

export default ({labelWidth, children, empty, small, mobileHeaders, headers, headersTr, cs, objs, data, td, tds, tr, row, render, style={}, stickyHeader, ...props}) => {
  if (empty && !objs.length)
    return empty;

  style.width = style.width || "100%";
  if (small)
    cs = "ant-table-small";

  if (mobileHeaders && Device.xs)
    headers = mobileHeaders;

  const headStyle = stickyHeader ? {position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, fontWeight: 'bold'} : {fontWeight: 'bold'};

  return <table className={"ant-table round-table " + cs} style={style} {...props}>
    {stickyHeader && headers && (
      <thead className="ant-table-thead">
        <tr style={headStyle}>{headers.map((h, i) => <th key={i} style={{fontWeight: 'bold'}}>{typeof h === "string" ? newliner(h) : h}</th>)}</tr>
      </thead>
    )}
    <tbody className="ant-table-tbody">
    {!stickyHeader && headers && <tr style={{fontWeight: 'bold'}}>{headers.map((h, i) => <td key={i}>{typeof h === "string" ? newliner(h) : h}</td>)}</tr>}
    {headersTr}
    {render && objs.map((o, i) => render(o, i))}
    {tr && objs.map((o, i) => <tr key={o.id || i}>{tr(o, i)}</tr>)}
    {row && objs.map((o, i) => row(o, i))}
    {td && objs.map((o, i) => <tr key={o.id || i}><td>{td(o, i)}</td></tr>)}
    {tds && objs.map((o, i) => <tr key={o.id || i}>{tds(o, i).map((v, j) => <td key={j}>{v}</td>)}</tr>)}
    {data && data.map((o, i) => <tr key={i}>{o.map((v, j) => <td style={{width: j===0 && labelWidth}} key={j}>{v}</td>)}</tr>)}
    {children}
    </tbody>
  </table>
}

